/** Scroll registration wizard to top after step transitions (window + `.reg-main` scroll container). */
export function scrollRegistrationToTop(mainEl?: HTMLElement | null): void {
  const main = mainEl ?? document.querySelector<HTMLElement>('.reg-main')
  if (main) {
    main.scrollTo({ top: 0, left: 0 })
    main.scrollLeft = 0
  }
  window.scrollTo({ top: 0, left: 0 })
  document.documentElement.scrollTop = 0
  document.documentElement.scrollLeft = 0
  document.body.scrollTop = 0
  document.body.scrollLeft = 0
}
